import {CreateStoreServiceFormValues} from "../reducers/create-service/types";
import {
  createEditStoreServiceDto,
  createStoreServiceDto,
} from "../create-store-service-service";
import {useCreateStoreServiceContext} from "../context/create-service";
import {useCreateStoreServiceApi} from "../../../../react-query-hooks/store/services/create-services";
import {CreateStoreServiceApiResponse} from "../../../../react-query-hooks/store/services/create-services/types";
import {useUpdateStoreServiceApi} from "../../../../react-query-hooks/store/services/update-store-service";
import {message} from "antd";
import {UpdateStoreServiceApiResponse} from "../../../../react-query-hooks/store/services/update-store-service/types";

interface HookResult {
  createStoreService(values: CreateStoreServiceFormValues): void;
  wasStoreServiceCreated: boolean;
  isCreatingService: boolean;
  responseData?: CreateStoreServiceApiResponse;
}

export function useCreateStoreServiceHook(): HookResult {
  const {dispatch} = useCreateStoreServiceContext();
  const createStoreServiceMutation = useCreateStoreServiceApi();

  const createStoreService = (values: CreateStoreServiceFormValues) => {
    console.log("createStoreService", values);
    createStoreServiceMutation.mutate(createStoreServiceDto(values), {
      onSuccess(data) {
        dispatch({
          type: "save-create-store-service-api-response",
          payload: {
            apiResponseData: data.data,
          },
        });
        dispatch({
          type: "save-create-store-service-form-values",
          payload: values,
        });
        dispatch({
          type: "update-create-service-form-step",
          payload: "coverImagesUpload",
        });
      },
    });
  };
  return {
    createStoreService,
    wasStoreServiceCreated: createStoreServiceMutation.isSuccess,
    isCreatingService: createStoreServiceMutation.isLoading,
    responseData: createStoreServiceMutation.data?.data,
  };
}

interface CreateEditServiceHookResult {
  createEditStoreService(values: CreateStoreServiceFormValues, cb: () => void): void;
  wasStoreServiceCreateEdited: boolean;
  isCreateServiceEditing: boolean;
  responseData?: UpdateStoreServiceApiResponse;
}

export function useCreateEditStoreServiceHook(): CreateEditServiceHookResult {
  const {dispatch, state} = useCreateStoreServiceContext();
  const createEditStoreServiceMutation = useUpdateStoreServiceApi();

  const createEditStoreService = (
    values: CreateStoreServiceFormValues,
    cb: () => void
  ) => {
    console.log("createEditStoreService", values);
    if (state.apiResponseData) {
      createEditStoreServiceMutation.mutate(
        createEditStoreServiceDto(values, {
          serviceId: state.apiResponseData.productService.id,
        }),
        {
          onSuccess(data) {
            dispatch({
              type: "save-create-store-service-api-response",
              payload: {
                apiResponseData: {
                  productService: {
                    booking_questions: data.data.updatedProductService.booking_questions,
                    createdAt: data.data.updatedProductService.createdAt,
                    deleted_at: data.data.updatedProductService.deleted_at,
                    delivery_timeframe_unit:
                      data.data.updatedProductService.delivery_timeframe_unit,
                    delivery_timeframe_value:
                      data.data.updatedProductService.delivery_timeframe_value,
                    description: data.data.updatedProductService.description,
                    hideFromProfile: data.data.updatedProductService.hideFromProfile,
                    id: data.data.updatedProductService.id,
                    name: data.data.updatedProductService.name,
                    request_phone_number:
                      data.data.updatedProductService.request_phone_number,
                    slug: data.data.updatedProductService.slug,
                    statusId: data.data.updatedProductService.statusId,
                    tiny_url: data.data.updatedProductService.tiny_url,
                    updatedAt: data.data.updatedProductService.updatedAt,
                    url_redirect: data.data.updatedProductService.url_redirect,
                    userId: data.data.updatedProductService.userId,
                  },
                },
              },
            });
            dispatch({
              type: "save-create-store-service-form-values",
              payload: values,
            });
            cb();
          },
        }
      );
      return;
    }
    message.error("No service id found. Go back to step 1");
  };
  return {
    createEditStoreService,
    wasStoreServiceCreateEdited: createEditStoreServiceMutation.isSuccess,
    isCreateServiceEditing: createEditStoreServiceMutation.isLoading,
    responseData: createEditStoreServiceMutation.data?.data,
  };
}
